import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton, InputAdornment } from '@mui/material';
import { SEARCH_ICON } from '../../constants/icons/SearchIcon';
import { COLOR_MAP } from '../../constants/ColorNames';
import styled from '@emotion/styled';
import { LabelValueType } from '../../types/dataTypes';



type DropdownProps = {
    id: string,
    label: string,
    value: string,
    options: LabelValueType[],
    placeholder?: string,
    // selectedValue: LabelValueType,
    inputValue: string,
    onInputChange: (event: React.SyntheticEvent, newValue: string) => void,
    onValueSelect: (event: React.SyntheticEvent, newValue: LabelValueType) => void,
    renderOption: (props: object, option: LabelValueType) => React.ReactNode,
    onCreateClick: () => void,
    showError?: boolean,
    errorMessage? : string,
    isFetchingFolders: boolean,
    disabled?: boolean
}


const StyledAutoComplete = styled(Autocomplete)`
    .MuiAutocomplete-input{
        padding:0 !important
       
    }
    .MuiOutlinedInput-root {
       padding: 1.2rem!important

    }
`

const SearchAndSelectDropDown = (props: DropdownProps) => {
    const [isCreateDisable, setIsCreateDisable] = useState(true)


    const { id,
        options,
        placeholder = '',
        // selectedValue,
        inputValue,
        onInputChange,
        onValueSelect,
        onCreateClick,
        showError,
        renderOption,
        errorMessage,
        isFetchingFolders,
        disabled = false
    } = props

    const handleCreateClick = () => {
        setIsCreateDisable(true);
        onCreateClick();
    }
    return (
        <StyledAutoComplete
            // value={selectedValue}
            freeSolo
            onChange={(event, newValue) => {
                onValueSelect(event, newValue as LabelValueType);
            }}
            disabled={disabled}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                onInputChange(event, newInputValue);
            }}
            id={id}
            options={options}
            filterOptions={(options, state) => {
                let updatedOptionsArray = options.filter((option : any) => option.label.toLowerCase().includes(state.inputValue?.toLowerCase()))
                if (updatedOptionsArray.length > 0 || !state.inputValue) {
                    setIsCreateDisable(true)
                }
                else {
                    setIsCreateDisable(false)
                }
                return updatedOptionsArray
            }}
            renderOption={(props, option) => renderOption(props, option as LabelValueType)}
            renderInput={(params) => <TextField
                {...params}
                error={showError}
                helperText={errorMessage}
                InputProps={{
                    ...params.InputProps,
                    startAdornment: <InputAdornment position="start">{SEARCH_ICON}</InputAdornment>,
                    endAdornment: <IconButton style={{ color: (isCreateDisable || isFetchingFolders) ? COLOR_MAP.BORDER_GREY : COLOR_MAP.DARK_PURPLE,  fontFamily: 'Noto Sans', fontSize: '1.4rem'}} onClick={(isCreateDisable || isFetchingFolders) ? undefined : handleCreateClick} disableRipple>Create</IconButton>
                }}
                placeholder={placeholder} />}
        />

    );
}

export default SearchAndSelectDropDown